import React, { Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import GoogleLogin from 'react-google-login'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { withCookies } from 'react-cookie'
import { withRouter } from 'react-router-dom'
import { withFormik } from 'formik'
import * as Yup from 'yup'
import { compose, withHandlers, withStateHandlers } from 'recompose'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logIn } from '../../store/effects/auth'

import RememberModal from './RememberModal'

import {
  Card,
  Logo,
  Label,
  ErrorSubtitle,
  Subtitle,
  FacebookBtn,
  withGoogleBtn,
  LoginInput,
  LoginBtn,
  ForgotPasswordLink
} from './components'

const LoginCard = styled(Card)`
  padding-top: 10%;
  max-width: 400px;
  padding: 0px 10px;
`

const GoogleLoginBtn = withGoogleBtn(GoogleLogin)

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logIn
    },
    dispatch
  )

const withLoginHanlders = compose(
  connect(null, mapDispatchToProps),
  withRouter,
  withCookies,
  withStateHandlers(
    () => ({
      showModal: false,
      loginError: null,
      redirectToReferrer: false
    }),
    {
      toggleModal: ({ showModal }) => () => ({ showModal: !showModal }),
      setError: props => error => ({ ...props, loginError: error }),
      setToReferrer: props => value => ({
        ...props,
        redirectToReferrer: !!value
      })
    }
  ),
  withHandlers({
    handleLogin: ({ cookies, setError, setToReferrer, onLogin }) => ({
      login
    }) => {
      if (login.msg) return setError(login.msg)

      if (login.id) {
        cookies.set('CookunityAwesomeCookie', login, {
          path: '/',
          expires: new Date(Date.now() + process.env.REACT_APP_AUTH_EXP_TOKEN)
        })
        if (onLogin) {
          onLogin()
        } else {
          setToReferrer(true)
        }
      }
    }
  }),
  withHandlers({
    doClassicLogin: ({ handleLogin, logIn }) => ({ email, password }) =>
      logIn({ email, password }).then(res => handleLogin(res)),
    doFacebookLogin: ({ handleLogin, setError, logIn }) => res => {
      if (res.email) {
        return logIn({
          email: res.email,
          password: process.env.REACT_APP_MAGENTO_TAG
          //accessToken: res.accessToken
        }).then(handleLogin)
      }

      setError('We could not log in on facebook')
    },
    doGoogleLogin: ({ handleLogin, logIn }) => res => {
      logIn({
        email: res.profileObj.email,
        password: process.env.REACT_APP_MAGENTO_TAG,
        accessToken: res.accessToken
      }).then(handleLogin)
    },
    doGoogleLoginFailed: ({ setError }) => err => {
      const ErrorMessage = {
        idpiframe_initialization_failed: '',
        popup_closed_by_user:
          'Ohh, its seems you closed the login window, please try again',
        access_denied:
          'Access denied by user, please provide the correct permissions and try again',
        immediate_failed: ''
      }
      setError(ErrorMessage[err.error])
    }
  }),
  withFormik({
    mapPropsToValues: props => ({
      email: '',
      password: ''
    }),
    validationSchema: Yup.object().shape({
      email: Yup.string().email(),
      password: Yup.string().required('Password required')
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
      setSubmitting(true)
      props
        .doClassicLogin({ ...values })
        .then(() => setSubmitting(false))
        .catch(() => {
          setSubmitting(false)
          props.setError('invalid username or password')
        })
    }
  })
)

const LoginView = ({
  location,

  values,
  errors,
  // touched,
  handleChange,
  handleBlur,
  submitForm,
  isSubmitting,

  toggleModal,
  showModal,

  redirectToReferrer,
  loginError,
  doFacebookLogin,
  doGoogleLogin,
  doGoogleLoginFailed
}) => {
  const { from } = location.state || { from: { pathname: '/' } }

  if (redirectToReferrer) {
    return <Redirect to={from} />
  }
  return (
    <Fragment>
      <RememberModal isOpen={showModal} onClose={() => toggleModal()} />
      <LoginCard>
        <Logo />
        <Label>Log in</Label>
        <FacebookLogin
          appId={process.env.REACT_APP_FB_APP_ID}
          callback={doFacebookLogin}
          fields="email"
          autoLoad
          render={renderProps => <FacebookBtn onClick={renderProps.onClick} />}
        />
        <GoogleLoginBtn
          clientId={process.env.REACT_APP_GOOGLE_APP_ID}
          onSuccess={doGoogleLogin}
          onFailure={doGoogleLoginFailed}
        />
        {loginError && <ErrorSubtitle>{loginError}</ErrorSubtitle>}
        <Subtitle>Or</Subtitle>
        <LoginInput
          placeholder="Email"
          type="email"
          name="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          withError={errors.email}
        />
        <LoginInput
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          withError={errors.password}
        />
        <LoginBtn onClick={() => submitForm()} disabled={isSubmitting}>
          {!isSubmitting ? 'Log in' : 'Loading'}
        </LoginBtn>
        <ForgotPasswordLink onClick={() => toggleModal()}>
          Don't remember your password?
        </ForgotPasswordLink>
      </LoginCard>
    </Fragment>
  )
}
export default compose(withLoginHanlders)(LoginView)



// WEBPACK FOOTER //
// ./src/modules/Login/login.js